// @flow

export const OPEN_SEARCH_NOTIFICATION_CONFIRM_DELETE_MODAL =
  'WEB_PUSH/OPEN_SEARCH_NOTIFICATION_CONFIRM_DELETE_MODAL';
export const CLOSE_SEARCH_NOTIFICATION_CONFIRM_DELETE_MODAL =
  'WEB_PUSH/CLOSE_SEARCH_NOTIFICATION_CONFIRM_DELETE_MODAL';
export const DELETE_SEARCH_NOTIFICATION_REQUEST = 'WEB_PUSH/DELETE_SEARCH_NOTIFICATION_REQUEST';
export const DELETE_SEARCH_NOTIFICATION_SUCCESS = 'WEB_PUSH/DELETE_SEARCH_NOTIFICATION_SUCCESS';
export const DELETE_SEARCH_NOTIFICATION_ERROR = 'WEB_PUSH/DELETE_SEARCH_NOTIFICATION_ERROR';



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/DeleteSearchNotification/actionTypes.js